module.exports = __webpack_public_path__ + "static/img/回收.a7887853.png";